document.addEventListener('DOMContentLoaded', function () {

    gsap.registerPlugin(ScrollTrigger);

    /* ----- LENIS ----- */

    const lenis = new Lenis({ smooth: true });

    //sync scroll trigger animations
    lenis.on("scroll", ScrollTrigger.update);

    //make sure the animations are driven by gsap internal clock and not the browser defaults
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000); 
    });
    
    //disable lag smoothing for more responsive scrolling without jumpings
    gsap.ticker.lagSmoothing(0);


    /* ---------------- */


});